import { useEffect } from "react";
import Breadcrumb from "../../../components/breadcrumb";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import EstrellasHero from "../components/EstrellasHero";
import EstrellasTimeline from "../components/EstrellasTimeline";

function Estrellas() {
    useEffect(() => {
        document.title = "Estrellas";
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />

            <main className="relative z-10 max-w-7xl mx-auto w-full px-4 md:px-10 pt-2 pb-8 md:pb-10">
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/" },
                        { label: "Historia" },
                        { label: "Las Estrellas", isCurrent: true },
                    ]}
                    className="mb-4"
                />

                <EstrellasHero />
                <EstrellasTimeline />
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Estrellas;
